export const visit = (vm, at) => {
at({ "en": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "There was a network connection issue.", "message": "Please check your connection and try again.", "button": "Try again" } } } } });
};